
export const FormCheckbox = ({
  id,
  name,
  label,
  value,
  disabled,
  onChange,
  onBlur,
  onKeyDown,
  placeholder = null,
  error,
  touched,
  style,
  isLoading,
}) => {

  const classNames = () => {
    let result = "tw-w-auto tw-px-2 tw-py-0 tw-text-indigo-700 sm:tw-text-sm focus:tw-outline-none tw-rounded disabled:tw-opacity-50 disabled:tw-cursor-not-allowed ";
    if (error && touched) {
      result += "tw-placeholder-red-300 focus:tw-ring-red-500 focus:tw-border-red-500 tw-border-red-300 tw-border-2 tw-text-red-900 ";
    } else {
      result += "focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-indigo-700 focus:tw-border-indigo-700 tw-border tw-border-gray-500 ";
    }
    if (isLoading) {
      result += " tw-opacity-50 disabled:tw-cursor-not-allowed ";
    }

    return result;
  }

  return (
    <>
      <input
        id={id}
        aria-label={label || 'checkbox'}
        title={label}
        type={"checkbox"}
        name={name}
        checked={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        style={style}
        className={classNames()}
      />
      {
        error && touched &&
        <span className="tw-px-1 tw-text-sm tw-text-red-800 tw-font-bold">
          {error}
        </span>
      }
    </>
  )
}